import Link from 'next/link';
import Image from 'next/image';
import siteConfig from '@/lib/config/site';
import HeaderIcon from '/public/static/images/icon/SupplySense360Full.png';

interface LogoProps {
  href?: string;
  className?: string;
}

export function MainLogoText({ href = '/' }: LogoProps) {
  return (
    <Link
      href={href}
      className="inline-flex items-center gap-3 
      hover:opacity-90 transition-opacity"
    >
      <Image
        src={HeaderIcon}
        alt={siteConfig.alt_name}
        width={200}
        height={40}
        className="h-12 w-auto"
        priority
      />
      {/*<span className="font-bold text-lg tracking-tight bg-gradient-to-r from-orange-500 via-orange-600 to-orange-800 text-transparent bg-clip-text">
        {siteConfig.alt_name}
      </span>*/}
    </Link>
  );
}